"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _MapVault_rawVault;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapVault = void 0;
const ta = __importStar(require("type-assertions"));
const rawVault_1 = require("./rawVault");
const util_1 = require("./util");
ta.assert();
class MapVault extends util_1.Revocable(Map) {
    constructor(rawVault) {
        super();
        _MapVault_rawVault.set(this, void 0);
        this.addRevoker(() => this.clear());
        this.addRevoker(() => __classPrivateFieldGet(this, _MapVault_rawVault, "f").revoke());
        __classPrivateFieldSet(this, _MapVault_rawVault, rawVault, "f");
    }
    static prepare(params) {
        return __awaiter(this, void 0, void 0, function* () { return rawVault_1.RawVault.prepare(params); });
    }
    static open(id, password) {
        return __awaiter(this, void 0, void 0, function* () {
            yield MapVault.prepare();
            return new MapVault(yield rawVault_1.RawVault.open(id, password));
        });
    }
    static list() { return rawVault_1.RawVault.list(); }
    static meta(id) { return rawVault_1.RawVault.meta(id); }
    static delete(id) { return rawVault_1.RawVault.delete(id); }
    get id() {
        return __classPrivateFieldGet(this, _MapVault_rawVault, "f").id;
    }
    get meta() {
        return __classPrivateFieldGet(this, _MapVault_rawVault, "f").meta;
    }
    setPassword(password) {
        return __awaiter(this, void 0, void 0, function* () {
            yield __classPrivateFieldGet(this, _MapVault_rawVault, "f").setPassword(password);
            return this;
        });
    }
    load(deserializer) {
        return __awaiter(this, void 0, void 0, function* () {
            yield __classPrivateFieldGet(this, _MapVault_rawVault, "f").load((x) => __awaiter(this, void 0, void 0, function* () {
                const obj = JSON.parse(util_1.decoder.decode(x));
                yield deserializer(Object.entries(obj).map(([k, v]) => [k, Promise.resolve(v)]));
            }));
            return this;
        });
    }
    save(serializer) {
        return __awaiter(this, void 0, void 0, function* () {
            yield __classPrivateFieldGet(this, _MapVault_rawVault, "f").save(() => __awaiter(this, void 0, void 0, function* () {
                const payloadObj = (yield Promise.all((yield serializer()).map(([k, v]) => __awaiter(this, void 0, void 0, function* () { return [k, yield v]; }))))
                    .sort((a, b) => {
                    if (a[0] < b[0])
                        return -1;
                    if (a[0] > b[0])
                        return 1;
                    return 0;
                })
                    .reduce((a, [k, v]) => ((a[k] = v), a), {});
                return util_1.encoder.encode(JSON.stringify(payloadObj));
            }));
            return this;
        });
    }
    entriesAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield Promise.all(Array.from(this.entries()).map(([k, v]) => __awaiter(this, void 0, void 0, function* () { return [k, yield v]; })));
        });
    }
}
exports.MapVault = MapVault;
_MapVault_rawVault = new WeakMap();
Object.freeze(MapVault);
Object.freeze(MapVault.prototype);
Object.freeze(Object.getPrototypeOf(MapVault));
